import http from '../../services/config/config'
import { setAuthorization } from '../../services/config/config'
import router from '@/src/router/routes';

// const FormData = require('form-data')
var querystring = require('querystring')

export const state = {
  currentUser: getSavedState('auth.currentUser'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  async logIn({ commit, dispatch, getters }, { user, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return await http
      .post('/auth/login', { email: user, senha: password })
      .then((response) => {
        let user = response.data.dados

        if (user.access_token) setAuthorization(user.access_token)
        
        commit('SET_CURRENT_USER', user)
        return user
        
      })
      .catch(error => {
        console.log(error)
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
  },

  // register the user
  register({ commit, dispatch, getters }, { fullname, email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return http
      .post('/api/register', { fullname, email, password })
      .then((response) => {
        const user = response.data
        return user
      })
  },

  // register the user
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return http.post('/api/reset', { email }).then((response) => {
      const message = response.data
      return message
    })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null)

    if (state.currentUser != null) {
      commit('SET_CURRENT_USER', state.currentUser)
      if (state.currentUser.access_token)
        setAuthorization(state.currentUser.access_token)
      return state.currentUser
    } else {
      dispatch('logOut')
    }
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  http.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.token
    : ''
}
